import {JoinSocialLeagueI18n} from '@/locales/base.message.locales';

export const join_social_league: JoinSocialLeagueI18n = {
  title: 'JUNTE-SE À <span class="red--text">LIGA SOCIAL GLOBAL</span>',
  buttons: {
    contact_us: 'CONTATE-NOS',
    donate: 'DOAR',
    join_today: 'JUNTE-SE AGORA'
  },
  texts: {
    p1: `Existimos para facilitar o despertar das pessoas para realizar o bem de forma contagiante, transformando o sentimento de empatia em ações de efeito duradouro através de parcerias e inovação aberta:`,
    p2: `Como voluntário, colabore com um dos times IKONE de desafios dos ODS da ONU. E, ao emprestar seu talento, crie um impacto muito maior e escalável do que apenas uma doação financeira.`,
    p3: `Sua empresa pode patrocinar desafios por meio de parcerias com as mais efetivas e abrangentes organizações globais comprometidas com impacto social, alcançando uma taxa de retorno sob investimento em até 20x.`,
    p4: `Encorajamos a todos para sugerir desafios e utilizar soluções para replicar em suas comunidades.`
  },
};
